const RECORDER_STOP_HEADROOM_MS = 1000;
export const CAMERA_PRE_ROLL_MS = 2000;

export const recordingStopDelayMs = (requestedDurationMs, maxClipDurationMs) => {
  const serverSafeDuration = Math.max(
    1000,
    maxClipDurationMs - RECORDER_STOP_HEADROOM_MS,
  );
  return Math.min(requestedDurationMs, serverSafeDuration);
};

export const preRollTrimStartMs = (
  recordingStartedAt,
  swingStartedAt,
  preRollMs = CAMERA_PRE_ROLL_MS,
) => {
  if (!Number.isFinite(recordingStartedAt) || !Number.isFinite(swingStartedAt)) return null;
  return Math.max(0, swingStartedAt - recordingStartedAt - preRollMs);
};
